module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-analytic-5.2a6f2a13.svg";